import Skeleton from '@mui/material/Skeleton';
import { Grid } from '@mui/system';
import { userFormSkeletonClasses, UserFormStyledGrid } from './UserFormSkeleton.styles';



const UserFormSkeleton = () => (
  <UserFormStyledGrid container spacing={2}>
    <Grid size={{ md: 6, sm: 12 }}>
      <Skeleton animation="wave" variant="rectangular" className={userFormSkeletonClasses.input} />
      <br />
      <Grid container spacing={4}>
        <Grid size={{ md: 6 }}>
          <Skeleton animation="wave" variant="rectangular" className={userFormSkeletonClasses.input} />
        </Grid>
        <Grid size={{ md: 6 }}>
          <Skeleton animation="wave" variant="rectangular" className={userFormSkeletonClasses.input} />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ md: 6 }}>
          <Skeleton animation="wave" variant="rectangular" className={userFormSkeletonClasses.input} />
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid size={{ md: 12 }}>
          <Skeleton animation="wave" variant="rectangular" className={userFormSkeletonClasses.media} />
        </Grid>
      </Grid>
    </Grid>
    <Grid size={{ md: 6, sm: 12 }}>
      <Skeleton animation="wave" variant="rectangular" className={userFormSkeletonClasses.input} />
      <br />
      <Skeleton animation="wave" variant="rectangular" className={userFormSkeletonClasses.media} />
    </Grid>
  </UserFormStyledGrid>
);

export default UserFormSkeleton;
